/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { StepStateType } from './StepStateType';
import {
    StepStateTypeFromJSON,
    StepStateTypeFromJSONTyped,
    StepStateTypeToJSON,
} from './StepStateType';

/**
 * 
 * @export
 * @interface Step5SubSteps
 */
export interface Step5SubSteps {
    /**
     * 
     * @type {StepStateType}
     * @memberof Step5SubSteps
     */
    step5PersonalDetails: StepStateType;
    /**
     * 
     * @type {StepStateType}
     * @memberof Step5SubSteps
     */
    step5EmploymentAndTax: StepStateType;
    /**
     * 
     * @type {StepStateType}
     * @memberof Step5SubSteps
     */
    step5SecondLifeDetails: StepStateType;
    /**
     * 
     * @type {StepStateType}
     * @memberof Step5SubSteps
     */
    step5ThirdParties: StepStateType;
    /**
     * 
     * @type {StepStateType}
     * @memberof Step5SubSteps
     */
    step5PaymentMethods: StepStateType;
    /**
     * 
     * @type {StepStateType}
     * @memberof Step5SubSteps
     */
    step5AppointIntermediary: StepStateType;
    /**
     * 
     * @type {StepStateType}
     * @memberof Step5SubSteps
     */
    step5TrustAndPolicyDetails: StepStateType;
    /**
     * 
     * @type {StepStateType}
     * @memberof Step5SubSteps
     */
    step5TaxDetails: StepStateType;
    /**
     * 
     * @type {StepStateType}
     * @memberof Step5SubSteps
     */
    step5RelatedParties: StepStateType;
    /**
     * 
     * @type {StepStateType}
     * @memberof Step5SubSteps
     */
    step5JustPortfolio: StepStateType;
}

/**
 * Check if a given object implements the Step5SubSteps interface.
 */
export function instanceOfStep5SubSteps(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "step5PersonalDetails" in value;
    isInstance = isInstance && "step5EmploymentAndTax" in value;
    isInstance = isInstance && "step5SecondLifeDetails" in value;
    isInstance = isInstance && "step5ThirdParties" in value;
    isInstance = isInstance && "step5PaymentMethods" in value;
    isInstance = isInstance && "step5AppointIntermediary" in value;
    isInstance = isInstance && "step5TrustAndPolicyDetails" in value;
    isInstance = isInstance && "step5TaxDetails" in value;
    isInstance = isInstance && "step5RelatedParties" in value;
    isInstance = isInstance && "step5JustPortfolio" in value;

    return isInstance;
}

export function Step5SubStepsFromJSON(json: any): Step5SubSteps {
    return Step5SubStepsFromJSONTyped(json, false);
}

export function Step5SubStepsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Step5SubSteps {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'step5PersonalDetails': StepStateTypeFromJSON(json['Step5_PersonalDetails']),
        'step5EmploymentAndTax': StepStateTypeFromJSON(json['Step5_EmploymentAndTax']),
        'step5SecondLifeDetails': StepStateTypeFromJSON(json['Step5_SecondLifeDetails']),
        'step5ThirdParties': StepStateTypeFromJSON(json['Step5_ThirdParties']),
        'step5PaymentMethods': StepStateTypeFromJSON(json['Step5_PaymentMethods']),
        'step5AppointIntermediary': StepStateTypeFromJSON(json['Step5_AppointIntermediary']),
        'step5TrustAndPolicyDetails': StepStateTypeFromJSON(json['Step5_TrustAndPolicyDetails']),
        'step5TaxDetails': StepStateTypeFromJSON(json['Step5_TaxDetails']),
        'step5RelatedParties': StepStateTypeFromJSON(json['Step5_RelatedParties']),
        'step5JustPortfolio': StepStateTypeFromJSON(json['Step5_JustPortfolio']),
    };
}

export function Step5SubStepsToJSON(value?: Step5SubSteps | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Step5_PersonalDetails': StepStateTypeToJSON(value.step5PersonalDetails),
        'Step5_EmploymentAndTax': StepStateTypeToJSON(value.step5EmploymentAndTax),
        'Step5_SecondLifeDetails': StepStateTypeToJSON(value.step5SecondLifeDetails),
        'Step5_ThirdParties': StepStateTypeToJSON(value.step5ThirdParties),
        'Step5_PaymentMethods': StepStateTypeToJSON(value.step5PaymentMethods),
        'Step5_AppointIntermediary': StepStateTypeToJSON(value.step5AppointIntermediary),
        'Step5_TrustAndPolicyDetails': StepStateTypeToJSON(value.step5TrustAndPolicyDetails),
        'Step5_TaxDetails': StepStateTypeToJSON(value.step5TaxDetails),
        'Step5_RelatedParties': StepStateTypeToJSON(value.step5RelatedParties),
        'Step5_JustPortfolio': StepStateTypeToJSON(value.step5JustPortfolio),
    };
}

